import { render, staticRenderFns } from "./_AutocompleteBase.vue?vue&type=template&id=d54d20d6&"
import script from "./_AutocompleteBase.vue?vue&type=script&lang=js&"
export * from "./_AutocompleteBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports